import { createReducer, on } from '@ngrx/store';
import * as WorkflowActions from './workflow.actions';

export const workflowFeatureKey = 'workflow';

export interface State {
  workflowActivity: any;
}

export const initialState: State = {
  workflowActivity: [],
};

export const reducer = createReducer(
  initialState,

  on(
    WorkflowActions.loadWorkflowActivitySuccess,
    (state, { workflowActivity }) => ({
      ...state,
      workflowActivity,
    })
  ),
  on(WorkflowActions.updateWorkflowSuccess, (state, { workflowActivity }) => ({
    ...state,
    workflowActivity,
  })),

  on(WorkflowActions.updateCommentToWorkflow, (state, { comment }) => ({
    ...state,
    workflowActivity: { ...state.workflowActivity, comment },
  }))
);
